import Header from "parts/Header";
import Sitemap from "parts/Sitemap";
import React from "react";
import Footer from "parts/Footer";
import PageErrorMessage from "parts/PageErrorMessage";
import Document from "parts/Document";

export default function NotFound() {
  return (
    <Document>
      <Header theme="black" />
      <PageErrorMessage />
      <Sitemap />
      <Footer />
    </Document>
  );
}
